import {Input, Drawer, Button} from 'antd';
import React, {useState, useEffect, useContext, useRef } from 'react';
import "./conversation.scss"
import { useNavigate } from 'react-router-dom';
import {ReactComponent as Smile} from '../../assets/icons/hugeicons_smile.svg';
import HeadingNDescription from '../../reuseableComponents/headingNDescription/headingNDescription';
import Notification from '../../reuseableComponents/Notification';
import {getAllConversationsApi, getMessagesApi} from './apis/apis';
import LeftSection from './leftSection/leftSection';
import Messages from './Messages/Messages';
import {SocketContext} from "../../SocketContext";
import {SmileOutlined, SendOutlined} from "@ant-design/icons";
import EmojiPicker from "emoji-picker-react";

const Conversation = () => {
    const [state, setState] = useState({
        drawer: false,
        allConversations: [],
        allMessages: [],
        msgInput: '',
        selectedConversationId: null,
        newMessage:null
    })

    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const scrollRef = useRef(null);
    const navigate = useNavigate()

    const socket = useContext(SocketContext);
    let isLoggedIn = localStorage.getItem("token") && localStorage.getItem("userLogin");

    const openDrawer = () => {
        setState({
            ...state,
            drawer: true
        })
    }

    const getAllConversationFunc = async () => {
        try {
            const result = await getAllConversationsApi();

            if (result?.data?.success) {
                const sortedConversations = result?.data?.data?.length > 0  ? result?.data?.data.sort((a, b) => {
                    const aDate = a.lastMessage?.createdAt || a?.createdAt;
                    const bDate = b.lastMessage?.createdAt || b?.createdAt;

                    return new Date(bDate) - new Date(aDate);
                }) : []

                setState({
                    ...state,
                    allConversations: sortedConversations
                })
            } else {
                Notification('error', "Error", "Error");
            }
        } catch (err) {
            Notification('error', "Error", "Error");
        }
    }

    useEffect(() => {

        isLoggedIn && getAllConversationFunc()


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        const el = scrollRef.current;
        if (el) {
            el.scrollTop = el.scrollHeight;
        }
    }, [ state.allMessages?.length]);

    useEffect(() => {
        if (!socket) return;

        socket.on('message', (newMessage) => {
            console.log("New message received:", newMessage);
            const updatedConversations = state.allConversations.map(conv => {
                if (conv.id === newMessage.conversationId) {
                    return {
                        ...conv,
                        lastMessage: newMessage
                    };
                }
                return conv;
            });

            const sortedConversations = updatedConversations.sort((a, b) => {
                const aDate = a.lastMessage?.createdAt || a.createdAt;
                const bDate = b.lastMessage?.createdAt || b.createdAt;
                return new Date(bDate) - new Date(aDate);
            });

            setState(prevState => ({
                ...prevState,
                allConversations: sortedConversations,
                allMessages: newMessage.conversationId === state.selectedConversationId ? [...prevState.allMessages, newMessage] : state.allMessages
            }))
        });


        return () => {
            socket.off('message');
        };
    }, [socket, state.selectedConversationId]);

    let userId = parseInt(localStorage.getItem("userId"));

    const sendMessage = () => {
        if (state.selectedConversationId && state.msgInput && !!socket) {

             socket.emit('message', {
                conversationId: state.selectedConversationId,
                message: state.msgInput,
                type: 'text'
            })
            setState({
                ...state,
                msgInput: '',
            })
        }
    }

    const addEmoji = (emojiObject) => {
        setState({
            ...state,
            msgInput: state.msgInput + emojiObject.emoji,
        });
    };


    return !!isLoggedIn ? <div className={"all-container"} style={{
        padding: 30,
        paddingBottom: 0
    }}>
        <div className={"conversationContainer"}>
            <div className={"left"}>
                <LeftSection
                    openDrawer={openDrawer}
                    converstaions={state.allConversations}
                    selectedConversationId={state.selectedConversationId}
                    selectedCnv={async (id) => {
                        let msg = await getMessagesApi(id);
                        setState({...state, selectedConversationId: id, allMessages: msg?.data?.data?.messages});
                    }}/>
            </div>
            <div className={"right"}>
                { state.selectedConversationId ? <div ref={ scrollRef } style={ {
                    flexGrow: 1,
                    overflow: "scroll",
                    scrollbarWidth: "none"
                } }>
                    {
                        state.allMessages?.length > 0 &&state.allMessages.map(item => <div
                          style={ {
                              width: "100%",
                              display: "flex",
                              justifyContent: userId.toString() === item?.senderId.toString() ? "end" : "start"
                          } }>
                            <Messages
                              date={ item?.createdAt }
                              message={ item?.message }
                              direction={ userId === item?.senderId ? 1 : 0 }
                            />
                        </div>)
                    }
                </div> : <p style={ {
                    textAlign: "center",
                    marginTop: '5rem',
                    marginBottom: '5rem'
                } }>Select or create conversation to start!</p> }
                <div style={ {
                    height: 60
                } }>
                    { state.selectedConversationId && <div style={ {
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        width: "70%",
                        margin: "auto",
                        marginTop: 10
                    }}>

                        <SmileOutlined
                            style={{fontSize: 24, cursor: "pointer"}}
                            onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                        />

                        {showEmojiPicker && (
                            <div style={{position: "absolute", bottom: 60, zIndex: 1000}}>
                                <EmojiPicker onEmojiClick={addEmoji} searchDisabled={true}
                                             allowExpandReactions={false}/>
                            </div>
                        )}

                        <Input value={state.msgInput} placeholder={"Enter message here"} style={{
                            borderRadius: 30
                        }}
                               onKeyDown={(e) => {
                                   if (e.key === "Enter") {
                                       sendMessage();
                                   }
                               }}
                               size={"large"}
                               onChange={(e) => {
                                   setState({
                                       ...state,
                                       msgInput: e.target.value
                                   })
                               }}/>
                        <Button onClick={() => {
                            sendMessage()
                        }}><SendOutlined/></Button>
                    </div>}
                </div>
            </div>


        </div>
        <Drawer
            title="Chat"
            placement="bottom"
            onClose={() => setState({
                ...state,
                drawer: false
            })}
            open={state.drawer && window.innerWidth <= 790}
            height={"90%"}
        >
            <div style={{
                flexGrow: 1,
                overflow: "scroll",
                scrollbarWidth: "none"
            }}>
                {
                    state.allMessages.map(item => <div
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: userId === item.senderId ? "end" : "start"
                        }}>
                        <Messages
                            date={item.createdAt}
                            message={item.message}
                            direction={userId === item?.senderId ? 1 : 0}
                        />
                    </div>)
                }
            </div>
            <div style={{
                height: 60
            }}>
                <div style={{
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    width: "70%",
                    margin: "auto",
                    marginTop: 10
                }}>
                    <Smile/>
                    <Input value={state.msgInput}
                           placeholder={"Enter message here"}
                           style={{
                               borderRadius: 30
                           }}
                           onKeyDown={(e) => {
                               if (e.key === "Enter") {
                                   sendMessage();
                               }
                           }}
                           onChange={(e) => {
                               setState({
                                   ...state,
                                   msgInput: e.target.value
                               })
                           }}
                           size={"large"}/>

                    <Button onClick={() => {
                        sendMessage();
                    }}><SendOutlined/></Button>
                </div>
            </div>
        </Drawer>
    </div> : <div style={{
        paddingTop:100
    }}>
        <HeadingNDescription heading={"Logged in to continue"} description={
            <Button style={{
                marginTop:10
            }}  type={"primary"} onClick={()=>navigate("/login")}>Continue to login</Button>
        }/>
    </div>
}

export default Conversation